/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/pension_medium'
export default icon
